// 模型展示配置: 接口 /wenkoo-portal/agentScope/chat/models 返回的模型中,
// 下面列出的模型不在前端下拉框展示 (按 modelName / displayName 匹配, 忽略大小写)

export const HIDDEN_MODEL_NAMES: string[] = ["deepseek-v4-flash"]

interface ModelLike {
  displayName?: string
  modelName?: string
}

export function isHiddenModel(model: ModelLike): boolean {
  const names = [model?.modelName, model?.displayName]
    .filter(Boolean)
    .map((name) => String(name).toLowerCase())
  return HIDDEN_MODEL_NAMES.some((hidden) =>
    names.some((name) => name.includes(hidden.toLowerCase())),
  )
}

export function filterVisibleModels<T extends ModelLike>(items: T[]): T[] {
  return items.filter((item) => !isHiddenModel(item))
}
